<template>
  <div>
    <a
      data-toggle="collapse"
      :href="'#collapse_' + groupData.id"
      class="flex-container collapsed w-100 flex-body mt-3 d-flex group-item"
      style="justify-content: space-between"
    >
      <div class="item text-center d-flex w-100 pl-2">
        <img
          class="mt-1"
          :src="
            groupData.profile_image
              ? groupData.profile_image
              : '/assets/icon.jpg'
          "
          alt=""
          style="
            border: 1px solid #ffffff;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            background-color: #fff;
          "
        />
        <div class="item group-name text-white">{{ groupData.title }}</div>
      </div>
      <div class="item text-white text-right pr-3">
        <a
          href="javascript:void(0)"
          :data-target="'#deleteItemGroup' + groupData.id"
          data-toggle="modal"
          class="action-btn text-white mr-3"
          ><i class="fas fa-trash"></i
        ></a>
        <a
          href="javascript:void(0)"
          @click="setParentId(groupData.id)"
          data-target="#itemGroup"
          data-toggle="modal"
          class="action-btn text-white mr-3"
          ><i class="fa fa-plus"></i
        ></a>
        <a
          href="javascript:void(0)"
          @click="editGroup(groupData)"
          data-toggle="modal"
          class="action-btn text-white mr-3"
          ><i class="fas fa-pencil-alt"></i
        ></a>
        <a
          v-if="groupData.children.length > 0"
          href="javascript:void(0)"
          class="action-btn text-white"
          ><i class="fa fa-chevron-right mr-3"></i
        ></a>
        <router-link
          :to="{ name: 'settings.itemgroup', params: { id: groupData.id } }"
          class="action-btn text-white"
          ><i class="fa fa-eye" aria-hidden="true"></i
        ></router-link>
      </div>
    </a>
    <div class="collapse" :id="'collapse_' + groupData.id">
      <div class="card card-body">
        <itemgroup
          :group="child"
          :committees="committees"
          :members="members"
          v-for="child in groupData.children"
          :key="'group_' + child.id"
        ></itemgroup>
      </div>
    </div>

    <!--     ITEMGROUP Modal-->
    <div
      class="modal fade"
      :id="'edititemGroup' + groupData.id"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-7 col-12 pl-md-5 pr-md-5">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <h5 class="text-uppercase">Bewerk {{ group.title }}</h5>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="row mt-3 ml-2">
                        <div class="col-lg-6">
                          <input
                            v-model="groupData.active"
                            :id="'activeevent' + groupData.id"
                            class="form-check-input ml-1 mt-1"
                            type="checkbox"
                            value=""
                          />
                          <label
                            :for="'activeevent' + groupData.id"
                            class="ml-4"
                            >Actief</label
                          >
                        </div>
                        <div class="col-lg-6">
                          <input
                            v-model="groupData.public"
                            :id="'publicevent' + groupData.id"
                            class="form-check-input ml-1 mt-1"
                            type="checkbox"
                            value=""
                          />
                          <label
                            :for="'publicevent' + groupData.id"
                            class="ml-4"
                            >Publiek</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="name">Naam</label>
                      <input
                        v-model="groupData.title"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="textarea1">Omschrijving</label>
                      <editor
                        :key="'testarea' + groupData.id"
                        v-model="groupData.body"
                        :init="{
                          height: 200,
                          menubar: false,
                          plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount',
                          ],
                          toolbar:
                            'undo redo | formatselect | bold italic backcolor | \
                                                            alignleft aligncenter alignright alignjustify | \
                                                            bullist numlist outdent indent | removeformat | help',
                        }"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-5 col-12 pl-md-2 pr-md-5">
                <div class="row">
                  <div class="col-md-12 col-12 mb-3 p-0">Commissies</div>
                  <div class="col-md-12 col-12 pb-4">
                    <Multiselect
                      searchable
                      mode="tags"
                      v-model="groupData.selected_committees"
                      :options="committees"
                    />
                  </div>
                  <!-- <div class="col-md-12 col-12 pl-md-5 pt-4 pb-4 container-bg">
                    <div class="row">
                      <div
                        class="col-md-10 custom-scrollbar"
                        style="height: 200px"
                      >
                        <div
                          v-for="(comt, index) in committees"
                          :key="index"
                          class="form-check"
                        >
                          <input
                            @click="notify()"
                            v-model="comt.selected"
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            :id="'checkcomt_edit' + comt.id"
                          />
                          <label
                            class="form-check-label"
                            :for="'checkcomt_edit' + comt.id"
                          >
                            {{ comt.title }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
                <div class="row">
                  <div class="col-12 mb-3 p-0">Leden</div>
                  <div class="col-12">
                    <label for="">
                      <input
                        type="checkbox"
                        v-model="groupData.select_all_users"
                        id=""
                      />
                      Alle leden
                    </label>
                  </div>
                  <div class="col-12 pb-4" v-if="!groupData.select_all_users">
                    <Multiselect
                      searchable
                      mode="tags"
                      v-model="groupData.selected_users"
                      :options="members"
                    />
                  </div>

                  <!-- <div class="col-md-12 col-12 pl-md-5 pt-4 pb-4 container-bg">
                    <div class="row">
                      <div
                        class="col-md-10 custom-scrollbar"
                        style="height: 200px"
                      >
                        <div
                          v-for="(comt, index) in members"
                          :key="index"
                          class="form-check"
                        >
                          <input
                            v-model="comt.selected"
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            :id="'checkmemb_' + comt.id"
                          />
                          <label
                            class="form-check-label"
                            :for="'checkmemb_' + comt.id"
                          >
                            {{ comt.lastname + " " + comt.firstname }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <button
                  @click="updateItemgroup(groupData)"
                  class="btn-dark float-right mt-3"
                >
                  Opslaan
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--     Delete ITEMGROUP Modal-->
    <div
      class="modal fade"
      :id="'deleteItemGroup' + groupData.id"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row col-12">
              Weet je zeker dat je {{ groupData.title }} wilt verwijderen?
            </div>

            <div class="row">
              <div class="col-lg-12">
                <button
                  @click="deleteGroup"
                  class="btn-dark float-right mt-3 ml-2"
                >
                  Ja
                </button>
                <button
                  @click="hideDeleteModal"
                  class="btn-dark float-right mt-3 text-black"
                  style="
                    background-color: #f8f9fa !important;
                    border-color: #f8f9fa !important;
                  "
                >
                  Nee
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import itemgroup from "./itemgroup";
// import members from '../../../committees/pages/members';
import { mapState } from "vuex";
export default {
  name: "itemgroup",
  props: {
    group: {
      type: Object,
      default: () => ({}),
    },
    committees: {
      type: Array,
      default: () => [],
    },
    members: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    itemgroup: itemgroup,
    // members:members
  },
  data() {
    return {
      groupData: {
        children: [],
      },
    };
  },
  computed: {
    ...mapState({
      itemgroup_parent_id: (state) => state.itemgroup_parent_id,
    }),
  },
  methods: {
    editGroup(group) {
      var modalID = "#edititemGroup" + group.id;
      this.groupData.selected_committees = group.committees.map((c) => {
        return c.id;
      });

      this.groupData.selected_users = group.users.map((c) => {
        return c.id;
      });

      //group.selected_committees =
      /* var selected_committees = this.committees.map((d) => {
        d.selected = this.groupData.committees.find((e) => e.id == d.id)
          ? true
          : false;
        return d;
      });
      this.committees = selected_committees; */
      //this.notify();

      window.$(modalID).modal("show");
    },
    updateItemgroup(group) {
      /* var selected_committee_ids = this.committees
        .filter((d) => d.selected)
        .map((d) => d.id);
      group.selected_committees = JSON.stringify(selected_committee_ids); */
      group.committees = [];
      this.$store
        .dispatch("put", {
          endpoint: "api/v1/itemgroups/" + group.id,
          details: group,
        })
        .then((data) => {
          window.location.reload();
          console.log(data);
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
    deleteGroup() {
      this.$store
        .dispatch("delete", "api/v1/itemgroups/" + this.groupData.id)
        .then((d) => {
          console.log(d);
          window.location.reload();
        })
        .catch((e) => console.log(e));

      this.hideDeleteModal();
    },
    hideDeleteModal() {
      let modalID = "#deleteItemGroup" + this.groupData.id;

      window.$(modalID).modal("hide");
    },
    setParentId(id) {
      this.$store.state.itemgroup_parent_id = id;
    },
  },
  mounted() {
    this.groupData = { ...this.group };
    this.groupData.selected_committees = this.groupData.committees.map((c) => {
      return c.id;
    });
    this.groupData.selected_users = this.groupData.users.map((u) => {
      return u.id;
    });
  },
};
</script>
<style scoped>
.card-body {
  background: transparent;
  border: none;
  padding: 0px 0px 0px 30px;
}
.card-body .group-item {
  margin-top: 5px !important;
}
.group-item .fa-chevron-right {
  transform: rotate(90deg);
}
.group-item.collapsed .fa-chevron-right {
  transform: rotate(0deg);
}
.group-item {
  text-decoration: none;
}
.action-btn {
  font-size: 13px;
  margin-right: 5px;
}
.group-name {
  font-size: 12px;
  text-align: left;
  margin-left: 10px !important;
}
.search-box {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #292929;
  border-radius: 4px;
  height: 40px;
  width: 20rem;
}

.search-btn {
  background: transparent;
  border: unset;
  margin-left: -30px;

  -webkit-appearance: none;
}

.btn {
  background: #292929 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 18px !important;
}

.custom-row {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
  opacity: 1;
}

.flex-container {
  display: flex;
  flex-flow: row wrap;
  position: relative;
  width: auto;
  align-items: center;

  opacity: 1;
}

.flex-body {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 1px 5px #0000004b;
  border-radius: 20px;
}

.item {
  flex: 1 1 18%;
  height: auto;
  margin: 4px;
  padding: 0px 0;
  width: auto;
}
</style>
